import { Component, inject, OnInit } from '@angular/core';
import { FollowButton, HomeCard, HomeCardComponentType, HomeCardIcon, HomeCardLink } from '@tytapp/app/pages/home-page/home-cards.service';
import { AppConfig } from 'common';

@Component({
    selector: 'tyt-watch-on',
    templateUrl: './watch-on.component.html',
    styleUrls: ['./watch-on.component.scss']
})
export class WatchOnComponent implements HomeCardComponentType, OnInit {
    private appConfig = inject(AppConfig);

    card: HomeCard;
    fullBleed = true;
    more: HomeCardLink = { url: '/how-to-watch', label: 'Learn More' }
    exposeAppleTV: boolean;
    exposeAndroidTV: boolean;

    async ngOnInit() {
        this.exposeAppleTV = await this.appConfig.featureEnabled('apps.web.expose_apple_tv');
        this.exposeAndroidTV = await this.appConfig.featureEnabled('apps.web.expose_android_tv');
    }

}
